import i18n from '../lang/i18n.js' // eslint-disable-line
import { Utils } from '@/utils/Utils.js'

const formatDate = (value, locale = 'es-CL', options) => {
  let date = value
  if (date) {
    if (!(date instanceof Date)) {
      date = new Date(date)
    }
    return date.toLocaleDateString(locale, options)
  }
}

const formatDateLocale = (value) => {
  const locale = i18n.locale
  let date = value
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }

  if (date.dia && date.mes && date.anno) {
    if (!(date instanceof Date)) {
      date = new Date(date.anno, date.mes - 1, date.dia)
    }
    return date.toLocaleDateString(locale, options)
  } else if (date.dia === 0 && date.mes === 0 && date.anno === 0) {
    return '-'
  } else {
    return 'Invalid Date'
  }
}

const truncate = (text, length, clamp) => {
  clamp = clamp || '...'
  const node = document.createElement('div')
  node.innerHTML = text
  const content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
}

const toCurrency = (value) => {
  if (typeof value !== 'number') {
    return value
  }
  const locale = i18n.locale
  const currency = locale === 'en' ? 'USD' : 'EUR'
  var formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2
  })
  return formatter.format(value)
}

const toCurrencyCode = (value, code) => {
  if (typeof value !== 'number') {
    return value
  }

  const currency = {
    currency: Utils.getISOCode(code),
    currencyDisplay: 'symbol'
  }

  const options = {
    style: code !== undefined && code !== 0 ? 'currency' : 'decimal',
    ...(code !== undefined && code !== 0 && currency),
    minimumFractionDigits: 2
  }

  const locale = i18n.locale
  // Si se cambia el valor del parámetro "locale" cambian visualmente los simbolos, probar con "es-ES", "es-CO", "en-US" y comprobar que cambia la manera de mostrarlo
  const formatter = new Intl.NumberFormat(locale, options)

  return formatter.format(value)
}

const formatAccount = (iban, cta) => {
  cta = cta.match(/.{1,4}/g).toString().replaceAll(',', ' ')
  return `${iban} ${cta}`
}

export {
  formatDate,
  formatDateLocale,
  truncate,
  toCurrency,
  toCurrencyCode,
  formatAccount
}
